import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { window } from "../window";

/**
 * The ScrollToTop component scrolls to the top of the browser window whenever the pathname changes.
 */

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.setTimeout(() => {
      window.scrollTo({ behavior: "smooth", left: 0, top: 0 });
    });
  }, [pathname]);

  return null;
};

ScrollToTop.displayName = "ScrollToTop";
